export function getCategoryEmoji(category) {
    const map = {
        crash: '💥',
        bug: '🐛',
        ui: '🎨',
        translation: '🌐',
        suggestion: '💡',
    };
    return map[category] || '⚪';
}

export function getPlatformEmoji(platform) {
    const map = { android: '🤖', ios: '🍎', web: '🌐' };
    return map[platform] || platform;
}

export function formatDate(value) {
    if (!value) return '—';
    return new Date(value).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function getLevelBadge(level) {
    const badges = {
        bronze: '🥉 Бронза',
        silver: '🥈 Серебро',
        gold: '🥇 Золото',
        platinum: '💎 Платина',
    };
    return badges[level] || '🥉 Новичок';
}
